import type { UserCard } from '@shared/types';
import { initials, userName, cx } from '../lib/format';

type Size = 'xs' | 'sm' | 'md' | 'lg' | 'xl';
interface Props {
  user: Pick<UserCard, 'display_name' | 'handle' | 'avatar_url'>;
  size?: Size;
  class?: string;
  title?: string;
}

/** Circle avatar with initials fallback (no image → colored initials). */
export function UserAvatar({ user, size = 'md', class: cls, title }: Props) {
  const name = userName(user);
  const c = cx('avatar', size !== 'md' && size, cls);
  if (user.avatar_url) {
    return <img class={c} src={user.avatar_url} alt={name} title={title ?? name} loading="lazy" />;
  }
  return (
    <span class={c} role="img" aria-label={name} title={title ?? name}>
      {initials(name)}
    </span>
  );
}
